import React from 'react';
import ReactDOM from 'react-dom';
import { Routes } from './routes/Routes';
import reportWebVitals from './reportWebVitals';
import './App.scss';

ReactDOM.render(
  <React.StrictMode>
    <Routes />
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();
